import React from 'react';
import PropTypes from 'prop-types';

import PriceTag from '@components/common/price_tag'


class FunnelBreadcrumbsCleanerPriceInfo extends React.Component {

    static propTypes = {
        cleaner: PropTypes.object,
        totalPrice: PropTypes.number,
    };

    hasRating = () => {
        return this.props.cleaner.rating !== null && this.props.cleaner.rating > 0;
    };

    content = () => {
        if (this.props.cleaner)
            return (
                <div className={'company-selection-info'}>
                    {this.hasRating() && <span className='rating-info green-text'>
                        <span className="glyphicon glyphicon-star" aria-hidden="true"/>
                        {this.props.cleaner.rating}
                    </span>}
                    <PriceTag amount={this.price()} className="price-tag"/>
                </div>
            );
        else
            return i18n.t("funnel.breadcrumbs.company-selection.content");
    };

    title = () => {
        if (this.props.cleaner)
            return this.props.cleaner.name;
        else
            return i18n.t("funnel.breadcrumbs.cleaner-selection.title")
    }

    price = () => {
        if (this.props.totalPrice)
            return this.props.totalPrice.toFixed(2);
        else
            return '';
    }

    render() {
        return (
            <div>
                <div className="little-darkblue-title">
                    {this.title()}
                </div>
                {this.content()}
            </div>
        );
    }
};

export default FunnelBreadcrumbsCleanerPriceInfo;
